import React, {
  useState,
  FunctionComponent,
  Dispatch,
  SetStateAction
} from "react";

//styles
import styled from "styled-components";
import SV from "../../styles/variables";
import MQ from "../../styles/mediaQueries";

//models
import { Frame, FrameEnum } from "../../models/frame";
import { IorderBy } from "./frameInfo";
interface Iprops {
  setStateOrderBy: Dispatch<SetStateAction<IorderBy>>;
  orderItems: (order: IorderBy, frames: Frame[]) => void;
  frames: Frame[];
}

const TableHeaderRowComponent: FunctionComponent<Iprops> = ({
  setStateOrderBy,
  orderItems,
  frames
}) => {
  return (
    <thead
      style={{
        width: "100%",
        display: "block",
        border: `1px solid ${SV.colorP4}`,
        borderLeft: "0px",
        borderRight: "0px"
      }}
    >
      <TableHeaderRow>
        <TableHeaderItem
          width={152}
          title={"Frame SKU"}
          type={"frameSKU"}
          orderItems={orderItems}
          frames={frames}
        />
        <TableHeaderItem
          width={104}
          title={"Price"}
          type={"price"}
          orderItems={orderItems}
          frames={frames}
        />
        <TableHeaderItem
          width={150}
          title={"Brand"}
          type={"brand"}
          orderItems={orderItems}
          frames={frames}
        />
        <TableHeaderItem
          width={100}
          title={"Color"}
          type={"color"}
          orderItems={orderItems}
          frames={frames}
        />
        <TableHeaderItem
          width={130}
          title={"Lens style"}
          type={"lensStyle"}
          orderItems={orderItems}
          frames={frames}
        />
        <TableHeaderItem
          width={148}
          title={"Number of views"}
          type={"numberOfViews"}
          orderItems={orderItems}
          frames={frames}
        />
      </TableHeaderRow>
    </thead>
  );
};

const defaultState = [
  {
    title: "Frame SKU"
  }
];

interface TableHeaderProps {
  width: number;
  title: string;
  type: FrameEnum;
  orderItems: (order: IorderBy, frames: Frame[]) => void;
  frames: Frame[];
}

const TableHeaderItem: FunctionComponent<TableHeaderProps> = ({
  width,
  title,
  type,
  orderItems,
  frames
}) => {
  return (
    <th
      style={{
        width: `${width}px`,
        display: "flex"
      }}
      key={title}
    >
      {title}
      <Arrow
        up={true}
        onClick={() => {
          orderItems({ type, reversed: false }, frames);
        }}
      />
      <Arrow
        up={false}
        onClick={() => {
          orderItems({ type, reversed: true }, frames);
        }}
      />
    </th>
  );
};

const TableHeaderRow = styled.tr`
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  text-align: left;
  th {
    font-size: 14px;
    font-weight: 300;
    color: #909090;
    display: flex;
    justify-content: flex-start;
    ${MQ.laptop} {
      font-size: 16px;
    }
  }
  ${MQ.laptop} {
    padding: 10px 16px;
  }
`;

interface ArrowProps {
  up: boolean;
  onClick: () => void;
}

const Arrow = styled.i<ArrowProps>`
  position: relative;
  display: block;

  color: #666;
  box-sizing: border-box;
  width: 5px;
  height: 5px;
  border-width: 1px 1px 0 0;
  border-style: solid;
  border-color: #c7c7c7; /*#3a76eb */
  margin-top: ${p => (p.up ? "3px" : "17px")};
  margin-left: ${p => (p.up ? "10px" : "4px")};
  transition: all 0.3s ease-in-out;
  :hover {
    border-color: #6d9cf9;
    :before {
      border-color: #6d9cf9;
    }
  }
  &:after,
  &:before {
    content: "";
    box-sizing: border-box;
  }
  &:before {
    right: 0px;
    top: -1px;
    position: absolute;
    height: 1px;
    border: solid #c7c7c7;
    border-width: 0.5px;
    transform: rotate(-45deg);
    width: 15px;
    transform-origin: right top;
  }
  transform: rotate(${p => (p.up ? "-45deg" : "135deg")}) scale(1.5);
` as FunctionComponent<ArrowProps>;

export default TableHeaderRowComponent;
